import React from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {closeModal, setCurrentStep, stepEnum} from '../IMEIDeviceRepairSlice';
import Title from '../Shared/Title';

const DeliveriesFound = (props) => {
  const showDeliveries = () => {
    props.setCurrentStep(stepEnum.UPDATE_DELIVERIES);
    props.closeModal();
  };

  const newDelivery = () => {
    props.setCurrentStep(stepEnum.CAUSE_SELECTION);
    props.closeModal();
  };

  return (
    <div className='error-popUp'>
      <Title text={`תאום שליחות לתיקון מכשיר`} subtext={`איך מתקדמים?`} />
      <div className='buttons-area'>
        <BtnSubmit text={'תיאום שליחות חדשה'} onclick={newDelivery} />
        <BtnSubmit text={'עדכון שליחות קיימת'} onclick={showDeliveries} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair};
};

const mapDispatchToProps = {closeModal, setCurrentStep};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveriesFound);
